import "./styles.scss";

const Progress = ({ percent }) => {
  return (
    <div className="progress-container">
      <div className="progress progress-striped active">
        <div style={{ width: `${percent}%` }} className="progress-bar" />
      </div>
    </div>
  );
};

export default Progress;
